import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  ContentContainer,
  QualificationItem,
  QualificationList,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionLead,
  SectionTitle,
  SplitGrid,
  SurfaceCard,
  SurfaceEyebrow,
  SurfaceTitle,
} from '../styles';

type BusinessesCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['businesses'];

type BusinessesSectionProps = {
  copy: BusinessesCopy;
};

export default function BusinessesSection({ copy }: BusinessesSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SplitGrid>
          <SectionIntro>
            <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
            <SectionTitle>{copy.title}</SectionTitle>
            <SectionLead>{copy.body}</SectionLead>
          </SectionIntro>
          <SurfaceCard>
            <SurfaceEyebrow>Qualification lens</SurfaceEyebrow>
            <SurfaceTitle>{copy.qualificationIntro}</SurfaceTitle>
            <QualificationList>
              {copy.qualifications.map((qualification) => (
                <QualificationItem key={qualification}>{qualification}</QualificationItem>
              ))}
            </QualificationList>
          </SurfaceCard>
        </SplitGrid>
      </ContentContainer>
    </Section>
  );
}
